import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { SparkCardComponent } from './components/card/card.component';
import { SparkCardHeaderComponent } from './components/header/card-header.component';

@NgModule({
  declarations: [SparkCardComponent, SparkCardHeaderComponent],
  imports: [CommonModule, SharedModule],
  exports: [SparkCardComponent]
})
export class SparkCardModule {}
